// extracted by mini-css-extract-plugin
module.exports = {"Review":"Review_Review__UrNkz","ReviewContent":"Review_ReviewContent__2E__n","PoweredBy":"Review_PoweredBy__1A3FQ","fade-in":"Review_fade-in__1CM_x"};